export default [
	'Agriculture',
	'Banking',
	'Chemicals',
	'Communications',
	'Construction',
	'Consulting',
	'Education',
	'Electronics',
	'Energy',
	'Engineering',
	'Entertainment',
	'Environmental',
	'Finance',
	'Food & Beverage',
	'Government',
	'Healthcare',
	'Hospice',
	'Hospitality',
	'Housing Association',
	'Insurance',
	'Machinery',
	'Manufacturing',
	'Mechanic',
	'Media',
	'Not For Profit',
	'Other',
	'Professional Services',
	'Recreation',
	'Retail',
	'Shipping',
	'Solicitor',
	'Technology',
	'Telecommunications',
	'Transportation',
	'Utilities'
]



// WEBPACK FOOTER //
// ./src/html/constants/industries.js